import { render, staticRenderFns } from "./coverage.vue?vue&type=template&id=5082f0e3&"
import script from "./coverage.vue?vue&type=script&lang=js&"
export * from "./coverage.vue?vue&type=script&lang=js&"
import style0 from "./coverage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "coverage.vue"
export default component.exports